import { Component, OnInit } from '@angular/core';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Participant } from 'src/app/shared/models/Participant';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { Form0ChurchAdress } from 'src/app/shared/models/Form0ChurchAdress';
import { State } from 'src/app/shared/models/State';
import { Address } from 'src/app/shared/models/Address';
import { WSAttendance } from 'src/app/shared/models/WSAttendance';
import { WSParticipantVO } from 'src/app/shared/models/WSParticipantVO';
import { WsParticipantsWrpVO } from 'src/app/shared/models/WsParticipantsWrpVO';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
@Component({
  selector: 'app-partipant-dtl',
  templateUrl: './partipant-dtl.component.html',
  styleUrls: ['./partipant-dtl.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class PartipantDtlComponent implements OnInit {

  //Elementos de traducción inicio.
  lstRespTranslate: TranslateRelLabelVO[];
  lbl_name: string="name_";
  lbl_lastName:string="last_name_";
  lbl_birth_date:String="birth_Date_";
  lbl_gender:string="gender_";
  lbl_language:string="language_";
  lbl_email:string="email_";
  lbl_cell_phone:string="cell_phone_";
  lbl_search:string="search_";
  lbl_back:String="back_";
  lbl_church:string="churchs_";
  lbl_service:string="service_";
  lbl_schedule:string="schedule_";
  lbl_participants:String="participants_";
  lbl_id:string="id_";
  lbl_zip_code:string="zip_code_";
  lbl_neightborhood:string="neightborhood_";
  lbl_county_city:string="county_city_";
  lbl_city_states:string="Citys_States_";
  lbl_address:String="address_";
  lbl_save:string="save_";
  lbl_select:string="select_";
  lbl_street_and_number:string="street_and_number_";
  lbl_confirm:string="confirm_";
  lbl_wish_continue:string= "wish_to_continue_";
  lbl_state:string="state";
  lbl_place_where_provide:String="place_where_provide_";
  
  //Elementos de traducción fin
  //Elementos de seguridad inicio
  token: string;
  security: SecurityDocument;
//Elementos de seguridad fin

  indexTab: number = 0;
  participantView: Participant;

  submitted: boolean;
  mailValid : boolean;
  birthday:Date;

  listLanguage : CategoryLan[];
  selectedLanguage: CategoryLan;
  wsParticipantsWrp: WsParticipantsWrpVO;

  listGender : CategoryLan[];
  selectedGender: CategoryLan;

  listState: State[];
  selectedState: State;

  form0Detail: Form0ChurchAdress;
  address:Address = {} as Address;

  maxDate: Date;




  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService) {
      
      const navigation = this.router.getCurrentNavigation();
      const dataParent = navigation.extras.state;
      if(dataParent){
        this.form0Detail = dataParent.service as Form0ChurchAdress;
        this.participantView = dataParent.participant as Participant;
        this.token = dataParent.token as string; 
        this.getSecurity();
        this.getStates(this.form0Detail.churchAdress.country);
        
        

      }else{
        this.redirectParent();
      }
      

    }

  ngOnInit(): void {
    this.birthday = this.tovpilUtils.convertStringToDate(this.participantView.birthDate);
    this.maxDate = new Date();
  }

  redirectParent(){
    let params = {};
    if(this.form0Detail){
      params["wrksId"] =  this.form0Detail.wrksId; 
      params["token"] =  this.token; 
    }
    this.router.navigate(['secretary/participants'],{ queryParams: params });
  }

  getCategoryByField(fieldId: string){
    this.apiService.getCategoryLang({
      "fieldId": fieldId,
      "language":this.security.language
    }).then(
      data => {
        if(fieldId == "language"){
          this.listLanguage = data
          for(let ct=0;ct<this.listLanguage.length;ct++){
            if(this.listLanguage[ct].descripTo==null || this.listGender[ct].descripTo===""){              
            }else{
              this.listLanguage[ct].descrip=this.listLanguage[ct].descripTo;
            }
            if(this.selectedLanguage==null && this.listLanguage[ct].fieldVal==this.form0Detail.language){
              this.selectedLanguage =this.listLanguage[ct];
            }
          }
          if(this.participantView.firstLang){
            this.selectedLanguage = this.listLanguage.find( l => l.fieldVal == this.participantView.firstLang);
          }


        }else if(fieldId == "sex"){
          this.listGender = data;
          for(let ct=0;ct<this.listGender.length;ct++){
            if(this.listGender[ct].descripTo==null || this.listGender[ct].descripTo==="" ){              
            }else{
              this.listGender[ct].descrip=this.listGender[ct].descripTo;
            }
          }
          if(this.participantView.gender){
            this.selectedGender = this.listGender.find( l => l.fieldVal == this.participantView.gender);
          }
        }
    })
  }

  getStates(country: string){
    this.apiService.getStatesByCountry(country).then(
      states => {
        this.listState = states;     
        if(this.participantView.address){
          this.getAddressParticipant(this.participantView.address);
        }
        
        if(this.selectedState==null){
          for(let ct=0;ct<this.listState.length;ct++){
            if(this.listState[ct].id.stateId==this.form0Detail.churchAdress.state){ 
               this.selectedState=this.listState[ct];
            }
          }
        }
        if(this.address.city==null){
          this.address.city=this.form0Detail.churchAdress.city;
        }
    })
  }

  saveParticipant(){
    this.confirmationService.confirm({
      message: this.lbl_wish_continue,
      header: this.lbl_confirm+ ' '+this.lbl_save,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.createParticipantSer();
      }
    });
  }

  createParticipantSer(){
    this.submitted = true;
    if(this.participantView.name && this.participantView.lastName && this.selectedLanguage && this.selectedGender 
      && this.birthday && this.selectedState && this.address.city && this.address.neight){
        if(this.participantView.email && !this.tovpilUtils.isEmailValido(this.participantView.email)){
          this.messageService.add({severity:'error', summary: 'Crear Participante', detail: 'Favor de llenar información requerida', life: 3000});
          return;
        }

        this.createParticipantService();

    }else{
      this.messageService.add({severity:'error', summary: 'Crear Participante', detail: 'Favor de llenar información requerida', life: 3000});
    }
  }

  createParticipantService(){

    this.participantView.name = this.participantView.name;
    this.participantView.lastName = this.participantView.lastName;
    this.participantView.birthDate = this.tovpilUtils.dateToTovpilDate(this.birthday);
    this.participantView.firstLang = this.selectedLanguage.fieldVal;
    this.participantView.gender = this.selectedGender.fieldVal;
    this.participantView.privData = true;
    if(!this.participantView.particiId){
      this.participantView.particiId = "";
    }
    

    this.address.country = this.form0Detail.churchAdress.country;
    this.address.state = this.selectedState.id.stateId;
    this.address.personType = "P"


    this.address.city = this.address.city;
    this.address.city = this.address.neight;

    

    const WsAttendanceKey = {wrksId:this.form0Detail.wrksId, sessNum:"00"};

    const wSAttendance:WSAttendance = {id: WsAttendanceKey, attendId:""}

    const wSParticipantVO:WSParticipantVO = {attendance:wSAttendance, participant:this.participantView, address: this.address, language: this.security.language}
    

    this.apiService.createWSParticipantWrp(wSParticipantVO).then(
      paticipant => {
        this.wsParticipantsWrp=paticipant;

        if(this.wsParticipantsWrp.status=='OK'){
           this.messageService.add({severity:'success', summary: 'Crear Participante', detail: 'Se creó participante correctamente', life: 3000});
           this.redirectParent();
        }else{
          this.messageService.add({severity:'error', summary: 'Crear Participante', detail: this.wsParticipantsWrp.errorMessage, life: 9000});
        }

    }).catch(error => {
      console.error(error);
      this.messageService.add({severity:'error', summary: 'Crear Participante', detail: error, life: 3000});
    });
  }


  getAddressParticipant(addrId: string){
    this.apiService.getAdressById({addrId:addrId}).then(
      addr => {
        this.address = addr;     
        
        this.selectedState = this.listState.find( l => l.id.stateId == this.address.state);
        
    })
  }
  getSecurity(){
    this.apiService.findSecurityById(
      {  
        "id":this.token
       }
      ).then(
      data => {
        this.security = data;           
        this.getTranslatedLabels();
        this.getCategoryByField("language");
        this.getCategoryByField("sex");
    });
  }
  getTranslatedLabels() {
    let map = new Map();
    let lstCat: CategoryLan[];
  
    this.apiService.listByLanguageMultFields(
      {
        'language': this.security.language,
        'region': this.security.region,
        'lstLabels': [this.lbl_name,this.lbl_lastName,this.lbl_birth_date,this.lbl_gender,
          this.lbl_language,this.lbl_email,this.lbl_cell_phone,this.lbl_search,this.lbl_back,this.lbl_church,
          this.lbl_schedule,this.lbl_service,this.lbl_participants,this.lbl_id,this.lbl_neightborhood,this.lbl_street_and_number,
        this.lbl_save,this.lbl_address,this.lbl_city_states,this.lbl_county_city,this.lbl_zip_code,this.lbl_select,this.lbl_confirm,this.lbl_wish_continue,this.lbl_state,this.lbl_place_where_provide]
      }
    ).then(
      trDocs => {
        this.lstRespTranslate = trDocs;

        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
       
        this.lbl_name=map.get(this.lbl_name);
        this.lbl_lastName=map.get(this.lbl_lastName);
        this.lbl_birth_date=map.get(this.lbl_birth_date);
        this.lbl_gender=map.get(this.lbl_gender);
        this.lbl_language=map.get(this.lbl_language);
        this.lbl_email=map.get(this.lbl_email);
        this.lbl_cell_phone=map.get(this.lbl_cell_phone);
        this.lbl_search=map.get(this.lbl_search);
        this.lbl_church=map.get(this.lbl_church);
        this.lbl_service=map.get(this.lbl_service);
        this.lbl_schedule=map.get(this.lbl_schedule);
        this.lbl_back=map.get(this.lbl_back);
        this.lbl_id=map.get(this.lbl_id);
        this.lbl_participants=map.get(this.lbl_participants);
        this.lbl_save=map.get(this.lbl_save);
        this.lbl_address=map.get(this.lbl_address);
        this.lbl_city_states=map.get(this.lbl_city_states);
        this.lbl_county_city=map.get(this.lbl_county_city);
        this.lbl_neightborhood=map.get(this.lbl_neightborhood);
        this.lbl_zip_code=map.get(this.lbl_zip_code);
        this.lbl_street_and_number=map.get(this.lbl_street_and_number);
        this.lbl_confirm=map.get(this.lbl_confirm);
        this.lbl_wish_continue=map.get(this.lbl_wish_continue);
        this.lbl_state=map.get(this.lbl_state);
        this.lbl_select=map.get(this.lbl_select);
        this.lbl_place_where_provide=map.get(this.lbl_place_where_provide);
      });
    }

}
